// src/components/HomeNoticias/HomeNoticiasCard.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import TagManager from 'react-gtm-module';
import styles from './HomeNoticiasCard.module.scss';

const MotionLink = motion(Link);

const buttonHover = {
  scale: 1.1,
  y: -5,
  boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.2)',
  backgroundColor: 'var(--tertiary-hover)',
  color: 'var(--text-color)',
};

const buttonTransition = {
  type: 'tween',
  ease: 'easeOut',
  duration: 0.2,
};

const HomeNoticiasCard = ({ noticia }) => {
  const handleClick = () => {
    if (typeof window !== 'undefined') {
      TagManager.dataLayer({
        dataLayer: {
          event: 'ux_event',
          event_name: 'home_ver_noticias',
          event_category: null,
          event_label: null,
          value: null,
          slug: null
        }
      });
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        {noticia.previsualizacion ? (
          <img
            src={noticia.previsualizacion}
            alt={noticia.titulo}
            className={styles.image}
          />
        ) : (
          <div className={styles.placeholder}>
            No Image Available
          </div>
        )}
      </div>

      <h3 className={styles.title}>
        {noticia.titulo}
      </h3>

      <div className={styles.buttonWrapper}>
        <MotionLink
          to={`/noticias/${noticia.slug}`}
          className={styles.button}
          onClick={handleClick}
          whileHover={buttonHover}
          transition={buttonTransition}
        >
          VER MÁS
        </MotionLink>
      </div>
    </div>
  );
};

export default HomeNoticiasCard;
